import { Popup } from './popup';

const mobMenu = new Popup('#jsMenuWrap', '#jsOpenMenu', '#jsCloseMenu');
mobMenu.init();

const user = new Popup('#jsUserWrap', '#jsOpenUser', '#jsCloseUser');
user.init();

const userBack = new Popup('#jsMenuWrap', '#jsUserBack', '#jsCloseMenu');
userBack.init();

const cart = new Popup('#jsCartWrap', '#jsOpenCart', '#jsCloseCart');
cart.init();

const cartDesk = new Popup('#jsCartWrap', '#jsOpenDeskCart', '#jsCloseCart');
cartDesk.init();

const filters = new Popup('#jsFiltersWrap', '#jsOpenFilters', '#jsClosefilters');
filters.init();
